export default "__VITE_ASSET__Ca7yM9eQ__"